module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tooltip":"The chart presents the number of offers in stores displayed in the widget (default settings).To check the number of offers in other stores, use the shop filter."}}')
  delete Component.options._Ctor
}
